<template>
	<div>
		<div class="nav_bar">
			<van-nav-bar
				title="支付"
				left-arrow
				@click-left="$router.go(-1)"
			/>
		</div>	
		<div style="height: 46px;"></div>
		<div v-if="loading" style="text-align: center; padding-top: 40%;">
			<van-loading type="spinner" color="#2f86f6"/>
		</div>
		<div v-else>
			<div class="payje">￥{{payAmount/100}}</div>
			<div class="pay_item_box">
				<van-radio-group v-model="type" >
					<van-cell-group>
						<van-cell title="微信支付" clickable @click="type = 'wxPay'">
							<template #icon>
								<div class="pay_item_icon">
									<van-icon name="wechat-pay" size="18" color="#21c67e"/>
								</div>	
							</template>
							<template #right-icon>
								<van-radio name="wxPay" checked-color="#2f86f6"/>
							</template>
						</van-cell>
						<van-cell title="余额支付" clickable @click="type = 'yepay'">
							<template #label>
								可用￥{{balance/100}}
							</template>
							<template #icon>
								<div class="pay_item_icon">
									<van-icon name="gold-coin" size="18" color="#ea553d"/>
								</div>
							</template>
							<template #right-icon>
								<van-radio name="yepay" checked-color="#2f86f6"/>
							</template>
						</van-cell>
						
					</van-cell-group>
				</van-radio-group>	
			</div>
			<div class="pay_btn">
				<van-button 
					type="primary" 
					round 
					color="#2f86f6" 
					@click="onPay"
					block 
					:disabled="type == 'yepay' && balance < invoice.customerMarketPrice"
				>立即支付
				</van-button>
			</div>
			
			<van-popup v-model="wxScanCodePay" round closeable style="width: 90%;" @close="isPay(0)">
				<div style="padding: 20px;">
					<div class="pay_title">微信扫码支付</div>
					<div style="padding:0 20px;">
						<van-image style="width: 100%;" :src="wxPayEwm">
							<template v-slot:loading>
								<van-loading type="spinner" size="20" />
							</template>
						</van-image>
					</div>
					<div style="text-align: center; color: #e12b2b; margin-bottom: 20px;  ">*温馨提示：请截图二维码，用微信扫码。<br/>*支付过程如果提示"当前交易异常"，请点"查看解决方案"，即可正常支付。</div>
					<van-button block round type="primary" @click="isPay(1)" color="#2f86f6" :disabled="findPayStatus" :loading="findPayStatus" loading-text="查询中...">已完成支付</van-button>
				</div>
			</van-popup>
		</div>
	</div>
</template>

<script>
	export default {
		data(){
			return {
				loading : false,
				invoice : {
				},
				payAmount:0,
				isWeChatBrowser : false,
				wxappToken : '',
				balance: 0,
				type: 'wxPay',
				findPayStatus : false,
				wxScanCodePay: false,
				wxPayEwm: '',
			};
		},
		mounted() {
			this.getInfo();
			this.findBalance();
			var ua = navigator.userAgent.toLowerCase();
			if(ua.match(/MicroMessenger/i)=="micromessenger"){
				this.isWeChatBrowser = true;
			}else{  
				this.isWeChatBrowser = false;
			}
		},
		methods: {
			getInfo(){
				this.loading = true;
				this.$get("/gtb/home/invoiceDetail.html",{invoiceId: this.$route.query.id}).then(res => {
					if( res.success ){
						this.getWxappToken();
						this.invoice = res.invoice;
						this.payAmount = res.invoice.zzsAmount + res.invoice.gsAmount + res.invoice.serviceAmount
					}
				}).catch(error=>{
					this.loading = false;
				});
			},
			findBalance(){
				this.$get('/gtb/home/findBalance.html').then(res=>{
					if( res.success ){
						this.balance = res.balance
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch(error=>{
					
				});;
			},
			getWxappToken(){
				this.$get('/gtb/findWetSet.html').then(res=>{
					this.loading = false;
					if( res.success ){
						this.wxappToken = res.wxappToken || '';
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch(error=>{
					this.loading = false;
				});
			},
			onPay(){
				if( this[this.type] ){
					this[this.type]();
				}else{
					this.$dialog({
						title : '提示',
						message: '支付类型不存在',
					});
				};
			},
			//微信支付
			wxPay(){
				this.$toast.loading({
					message: '支付中...',
					forbidClick: true,
					duration : 0
				});
				this.$post('/gtb/invoice/llWxPay.html', { invoiceId: this.invoice.id , isPcOrXcx: 2,wxappToken : this.wxappToken}).then(res => {
					this.$toast.clear();
					if (res.success) {
						if( this.isWeChatBrowser ){
							window.location.href = res.url;
						}else{
							this.wxScanCodePay = true;
							this.wxPayEwm = res.data;
						}
					} else {
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch(error => {
					this.$toast.clear();
				});
			},
			//余额支付
			yepay(){
				this.$toast.loading({
					message: '支付中...',
					forbidClick: true,
					duration : 0
				});
				this.$get('/gtb/invoice/pay.html',{ 
					invoiceId : this.invoice.id,
					tradeType : 3,
					wxappToken : this.wxappToken,
				}).then(res=>{
					this.$toast.clear();
					if( res.success ){
						this.paySuccess();
					}else{
						this.$dialog({
							title : '提示',
							message: res.msg,
						});
					}
				}).catch(error=>{
					this.$toast.clear();
				});
			},
			//支付成功提示
			paySuccess(){
				this.$toast({ 
					type : 'success',
					message : '支付成功',
					forbidClick : true
				});
				var _this = this;
				setTimeout(function () {
				  _this.$router.go(-1);
				}, 1000);
			},
			//查询是否支付
			isPay(type) {
				if( type == 1 ){
					this.findPayStatus = true;
				}
				this.$get('/gtb/home/invoiceDetail.html', {invoiceId: this.invoice.id}).then(res =>{
					this.findPayStatus = false;
					if (res.invoice.payInvoiceType == 2) {
						this.paySuccess();
					}else{
						if( type == 1 ){
							this.$toast.fail("未查询到支付");
						}
					}
				}).catch(() => {
					this.findPayStatus = false;
				});
			}
			
		},
	};
</script>
<style scoped>
	.payje{ text-align: center; font-size: 32px; padding: 26px 16px 26px 16px; font-weight: bold;}
	.pay_btn{ padding: 0 16px;}
	.pay_item_box{ margin-bottom: 32px;}
	.pay_item_icon{ width: 28px; line-height: 26px;}
	.pay_title{ text-align: center; font-size: 18px; }
</style>
